import { render } from "./SessionsAndBlocklistTabs.vue?vue&type=template&id=058a4624&ts=true"
import script from "./SessionsAndBlocklistTabs.vue?vue&type=script&lang=ts"
export * from "./SessionsAndBlocklistTabs.vue?vue&type=script&lang=ts"

import "./SessionsAndBlocklistTabs.vue?vue&type=style&index=0&id=058a4624&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__